export default {
    name: 'mixin',
    computed: {
        mTheme () {
          return this.$store.state.theme;
        },
        mHeader () {
          return this.$store.state.header;
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixin.js